var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "768px",
    height: "512px",
    viewBox: "0 0 768 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9, 0)",
    fillRule: "nonzero",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEEEE",
    points: "9 142 393 104 777 142 777 370 393 408 9 370"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF9811",
    points: "9 0 777 0 777 95.5723921 777 160 9 160"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6DA544",
    points: "0 352 777 352 777 512 0 512"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(321, 184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0052B4",
    cx: 72,
    cy: 72,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EEEEEE",
    cx: 72,
    cy: 72,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0052B4",
    cx: 72,
    cy: 72,
    r: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.ecc9e533df6f312d703d9b1fa9630d9a.svg";
export { ForwardRef as ReactComponent };